const items = [
  "Excellence",
  "Strategic Vision",
  "Luxury Apparel",
  "Business Development",
  "Digital Media",
  "Creating · Building · Adding Value",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {items.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="whitespace-nowrap px-10 font-serif text-lg italic tracking-wide text-stone-400 sm:text-xl">
          {item}
        </span>
        <span className="inline-block h-1.5 w-1.5 rotate-45 bg-[#D4AF37]/70" />
      </span>
    ))}
  </div>
);

const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee"
    className="marquee-paused overflow-hidden border-y border-[#1c1c1f] bg-[#0A0A0B] py-6"
    aria-hidden="true"
  >
    <div className="animate-editorial-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);

export default EditorialMarquee;
